type Never<T> = { [key in keyof T]: never };

function assertNever(
    //** Value that should be never */
    value: never,
    //** Optional error message to throw when value is not never */
    errorMessage?: string,
    options?: {
        //** If you don't wan't to throw, just get a type-check error, set to true */
        doNotThrow?: boolean;
        //* Include the value of the this prop of the value, not the whole object in the error message */
        valueProp?: keyof typeof value;
        doNotIncludeValueAsJsonInErrorMessage?: boolean;
        errorToThrow?: Error;
    },
): never {
    // If no throw, no throw
    if (options?.doNotThrow) return value;

    // Throw error with message that value should have been never
    throw (
        options?.errorToThrow ??
        new Error(
            (errorMessage ?? "Unexpected value. Should have been never") +
            options?.doNotIncludeValueAsJsonInErrorMessage
                ? ""
                : `; value was: ${
                      options?.valueProp
                          ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            JSON.stringify((value as any)[options.valueProp])
                          : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            JSON.stringify(value as any)
                  }`,
        )
    );
}

const assertTruthy = <T>(value: T): NonNullable<T> => {
    if (!value) throw new Error("Value is falsy");
    return value;
};

export { assertNever, assertTruthy };
export type { Never };
